import { render, staticRenderFns } from "./WindDetail.vue?vue&type=template&id=7b17d18a&scoped=true&"
import script from "./WindDetail.vue?vue&type=script&lang=js&"
export * from "./WindDetail.vue?vue&type=script&lang=js&"
import style0 from "./WindDetail.vue?vue&type=style&index=0&id=7b17d18a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b17d18a",
  null
  
)

export default component.exports